module.exports = __webpack_public_path__ + "media/images/p+w_comb_3-aaca300218a3f7242163bc90af751b5f.jpg";